import FormFieldIndicatorContainer from './FormFieldIndicatorContainer';

export default FormFieldIndicatorContainer;
